import { Box } from '@mui/material'
import React from 'react'
import './style/section1.css'

function Section1() {
  return (
  
       <Box className='mt-28'>
            <div className="shop-hero page-hero page-hero-small">
                <img src="https://ninetheme.com/themes/goldsmith/wp-content/uploads/2022/12/background-2-scaled-e1670573693696.webp" alt="" width="1920" height="1080" />
                <div className='z-40  text-white text-base' style={{ margin: '0 auto' }}>
                    <p className='uppercase text-center '>Stellare Bijoux COMPANY</p>
                    <p className='text-center text-5xl my-3 font-medium'> We believe we can all <br/>make a difference.</p>
                    <p className='text-center'>Aesthetic brunch polaroid bespoke, vice kale chips <br/>leggings 90’s selfies raw denim.</p>
                </div>
            </div>
        </Box>
    
  )
}

export default Section1
